(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/search.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/search.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.lyckoplatsen.logger;
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect;
const _svs$ui$reactForm = svs.ui.reactForm,
  Inputv2 = _svs$ui$reactForm.Inputv2,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Form = _svs$ui$reactForm.Form;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const _svs$ui$ReactListGrou = svs.ui.ReactListGroup,
  ListGroup = _svs$ui$ReactListGrou.ListGroup,
  ListItem = _svs$ui$ReactListGrou.ListItem;
const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom,
  useAtom = _jotai.useAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  mapLocationAtom = _svs$lyckoplatsen$com.mapLocationAtom,
  pinLocationAtom = _svs$lyckoplatsen$com.pinLocationAtom,
  pinLocationTypeAtom = _svs$lyckoplatsen$com.pinLocationTypeAtom,
  shouldShowOverlayAtom = _svs$lyckoplatsen$com.shouldShowOverlayAtom,
  shouldShowPinAtom = _svs$lyckoplatsen$com.shouldShowPinAtom;
const mapFlyToLevelAtom = svs.lyckoplatsen.shared_map.atoms.mapFlyToLevelAtom;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_play.utils,
  fetchGeolocationSearch = _svs$lyckoplatsen$com2.fetchGeolocationSearch,
  fetchGeolocationCoordinates = _svs$lyckoplatsen$com2.fetchGeolocationCoordinates;
const memoFetchGeoLocationSearch = _.memoize(fetchGeolocationSearch);
const memoFetchGeoLocationCoordinates = _.memoize(fetchGeolocationCoordinates);
const scrambleCoordinates = svs.tur.lyckoplatsen.map.scrambleCoordinates;
const showLocationCoordsError = svs.lyckoplatsen.components.page_play.utils.showLocationCoordsError;
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const PinIcon = svs.lyckoplatsen.shared_utils.react.components.PinIcon;
const Search = () => {
  const setMapLocation = useSetAtom(mapLocationAtom);
  const setPinLocation = useSetAtom(pinLocationAtom);
  const setPinLocationType = useSetAtom(pinLocationTypeAtom);
  const setShouldShowPin = useSetAtom(shouldShowPinAtom);
  const _useAtom = useAtom(shouldShowOverlayAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    shouldShowOverlay = _useAtom2[0],
    setShouldShowOverlay = _useAtom2[1];
  const setMapFlyToLevel = useSetAtom(mapFlyToLevelAtom);
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    input = _useState2[0],
    setInput = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentIndex = _useState4[0],
    setCurrentIndex = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasSelected = _useState6[0],
    setHasSelected = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    autoComplete = _useState8[0],
    setAutoComplete = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    noSuggestions = _useState0[0],
    setNoSuggestions = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    searchError = _useState10[0],
    setSearchError = _useState10[1];
  const hasOpenDialogRef = useRef(false);
  const inputRef = useRef(null);
  const listContainerRef = useRef(null);
  const closeAutoComplete = useCallback(() => {
    setShouldShowOverlay(false);
    setHasSelected(false);
    setAutoComplete([]);
    setInput('');
    setCurrentIndex(0);
  }, [setShouldShowOverlay]);
  const fetchSuggestions = async text => {
    let values;
    try {
      values = await memoFetchGeoLocationSearch(text);
    } catch (error) {
      logger.error('Error fetching search results', error);
      if (!hasOpenDialogRef.current) {
        hasOpenDialogRef.current = true;
        showLocationCoordsError(() => {
          hasOpenDialogRef.current = false;
        });
      }
      setSearchError(true);
      return;
    }
    if (!values || !values.places.length && !values.addresses.length) {
      setAutoComplete([]);
      setNoSuggestions(true);
    } else {
      const allValues = [...values.places, ...values.addresses];
      const reducedValues = allValues.slice(0, 15);
      setAutoComplete(reducedValues);
      setNoSuggestions(false);
      setSearchError(false);
    }
  };
  const debouncedFetchSuggestions = useRef(_.debounce(text => {
    if (!text.length) {
      setAutoComplete([]);
      setNoSuggestions(false);
      return;
    }
    fetchSuggestions(text);
  }, 500)).current;
  const scrollToItem = index => {
    if (listContainerRef.current) {
      const listItems = listContainerRef.current.querySelectorAll('.list-group-item');
      if (listItems[index]) {
        listItems[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }
  };
  const handleChange = e => {
    const text = e.target.value;
    setCurrentIndex(0);
    scrollToItem(0);
    setInput(text);
    debouncedFetchSuggestions(text);
  };
  const handleOnFocus = () => {
    setHasSelected(true);
    setShouldShowOverlay(true);
  };
  const handleOnBlur = () => {
    setTimeout(() => {
      closeAutoComplete();
    }, 600);
  };
  const handleSelect = async item => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Sök',
      opt_label: 'search'
    });
    if (!item) {
      return;
    }
    closeAutoComplete();
    let data;
    try {
      data = await memoFetchGeoLocationCoordinates(item.id);
    } catch (error) {
      logger.error('Error fetching coordinates', error);
    }
    if (!data) {
      if (!hasOpenDialogRef.current) {
        hasOpenDialogRef.current = true;
        showLocationCoordsError(() => {
          hasOpenDialogRef.current = false;
        });
      }
      return;
    }
    if (data.type === CONSTANTS.GEO_SEARCH_TYPES.ADDRESS) {
      setShouldShowPin(false);
      setPinLocationType(CONSTANTS.LOCATION_TYPES.OTHER);
      setMapFlyToLevel(CONSTANTS.PLACE_PIN_ZOOM_LEVEL);
      setPinLocation({
        lat: data.latitude,
        lng: data.longitude
      });
    } else {
      setMapLocation({
        lat: scrambleCoordinates(data.latitude),
        lng: scrambleCoordinates(data.longitude),
        zoomLevel: CONSTANTS.PLACE_PIN_ZOOM_LEVEL
      });
    }
  };
  const handleInputKeyDown = e => {
    switch (e.key) {
      case 'Tab':
        closeAutoComplete();
        break;
      case 'Escape':
        closeAutoComplete();
        handleOnFocus();
        break;
      case 'Enter':
        if (autoComplete[0]) {
          const mapEl = document.getElementById('mapPlay');
          mapEl.focus();
          const inputEl = document.querySelector('.standard-input');
          if (inputEl) {
            inputEl.blur();
          }
          handleSelect(autoComplete[currentIndex]);
        }
        break;
      case 'ArrowDown':
        e.preventDefault();
        setCurrentIndex(prevIndex => {
          const newIndex = (prevIndex + 1) % autoComplete.length;
          scrollToItem(newIndex);
          return newIndex;
        });
        break;
      case 'ArrowUp':
        e.preventDefault();
        setCurrentIndex(prevIndex => {
          const newIndex = (prevIndex - 1 + autoComplete.length) % autoComplete.length;
          scrollToItem(newIndex);
          return newIndex;
        });
        break;
      default:
        break;
    }
  };
  const handleListItemKeyDown = (e, index, item) => {
    switch (e.key) {
      case 'Tab':
        if (index === autoComplete.length - 1 && !e.shiftKey) {
          closeAutoComplete();
        }
        break;
      case 'Enter':
        handleSelect(item);
        break;
      default:
        break;
    }
  };
  const handleIconClick = e => {
    e.preventDefault();
    if (!hasSelected) {
      return;
    }
    handleSelect(autoComplete[currentIndex]);
  };
  const shouldShowAutoComplete = Boolean(input.length && hasSelected);
  useEffect(() => {
    if (!shouldShowOverlay) {
      closeAutoComplete();
    }
  }, [closeAutoComplete, shouldShowOverlay]);
  return React.createElement("div", {
    className: "lp-search",
    ref: inputRef
  }, React.createElement(Form, {
    isVertical: true
  }, React.createElement(ControlGroup, {
    v2: true,
    className: "lp-search-input-control relative"
  }, React.createElement(Inputv2, {
    id: "locationInput",
    autoComplete: "off",
    label: "S\xF6k din lyckoplats",
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    onChange: handleChange,
    onKeyDown: handleInputKeyDown,
    required: true,
    value: input,
    role: "combobox",
    "aria-label": "S\xF6k platser",
    "aria-autocomplete": "list",
    "aria-owns": "autocomplete-list",
    "aria-expanded": Boolean(input),
    "aria-controls": "autocomplete-list",
    "aria-haspopup": "listbox"
  }), React.createElement(IconButton, {
    className: "search-button",
    onClick: handleIconClick,
    title: "S\xF6k knapp",
    "aria-label": "Search",
    tabIndex: "-1"
  }, React.createElement(Icon, {
    icon: "search"
  })), shouldShowAutoComplete && React.createElement("div", {
    className: "lp-search-autocomplete-field",
    ref: listContainerRef
  }, React.createElement(ListGroup, {
    role: "listbox",
    "aria-label": "S\xF6k f\xF6rslag"
  }, noSuggestions && React.createElement(ListItem, {
    role: "alert",
    "aria-disabled": "true",
    className: "lp-no-suggestions"
  }, "Vi hittade ingen plats med det namnet. ", React.createElement("span", null, "Kolla stavningen eller testa en annan plats.")), searchError && React.createElement(ListItem, {
    role: "alert",
    className: "lp-error-item",
    "aria-disabled": "true"
  }, "Just nu fungerar inte s\xF6kfunktionen."), autoComplete.map((item, index) => {
    var _item$textDisplay;
    return React.createElement(ListItem, {
      key: _.uniqueId(),
      onKeyDown: event => handleListItemKeyDown(event, index, item),
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
        handleSelect(item);
      },
      role: "option",
      "aria-selected": currentIndex === index,
      className: currentIndex === index ? 'selected' : ''
    }, React.createElement("span", {
      className: "auto-complete-text"
    }, (_item$textDisplay = item.textDisplay) !== null && _item$textDisplay !== void 0 ? _item$textDisplay : item.text), !item.placeType && React.createElement(PinIcon, {
      className: "pin-icon",
      color: "black"
    }));
  }))))));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Search
});

 })(window);